export default __webpack_public_path__ + "static/tigernixCrmImage-fd4b1fd2be38a810dd2b5fb0d2f03251.webp";